import React, { useRef, useState, useEffect } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Link from '../atoms/Link'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const InpageNavBlock = ({ block }) => {
  const refNavScroll = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      console.log(refNavScroll.current.offsetTop)
      gsap.from(refNavScroll.current, {
        //duration: 1,
        scrollTrigger: {
          trigger: refNavScroll.current,
          toggleActions: 'play none none none',
          start: 'top ' + 90,
          end: 99999,
          toggleClass: 'scrolled-state',
        },
      })
    }, 1000)
  }, [])

  return (
    <section
      className="inpage-nav-block"
      ref={refNavScroll}
      style={{
        height: refNavScroll?.current?.offsetHeight
          ? refNavScroll?.current?.offsetHeight
          : '44px',
      }}
    >
      {block.inpage_nav_items?.length > 0 && (
        <div className="inpage-nav-block-bar">
          <div className="inpage-nav-block-container">
            <div className="inpage-nav-block-content">
              <div className="inpage-nav-block-breadcrumbs">
                {block.breadcrumbs?.map((breadcrumb, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <span> / </span>}
                    <Link link={breadcrumb.slug}>{breadcrumb.title}</Link>
                  </React.Fragment>
                ))}
              </div>
              <div className="inpage-nav-block-inpage-nav">
                <ul className="nav flex-row">
                  {block.inpage_nav_items.map((item, index) => (
                    <li className="nav-item" key={index}>
                      <AnchorLink
                        className="nav-link"
                        offset="100"
                        href={item.url}
                      >
                        <span>{item.title}</span>
                      </AnchorLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default InpageNavBlock
